module.exports = __webpack_public_path__ + "static/media/HAUX_NUTRICAO_1.ae330232.pdf";